import { cn } from "@repo/ui/lib/utils"
import * as React from "react"

interface JuloBadgeRightAction {
  icon: React.ReactNode
  onClick: () => void
  ariaLabel: string
}

interface JuloBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  rightAction?: JuloBadgeRightAction
  truncate?: boolean
}

const JuloBadge = React.forwardRef<HTMLSpanElement, JuloBadgeProps>(
  (
    {
      children,
      leftIcon,
      rightIcon,
      rightAction,
      truncate = false,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <span
        ref={ref}
        className={cn(
          "h-7 items-center gap-2 rounded-full border border-secondary-border bg-secondary-background px-3 text-xs font-medium text-foreground",
          truncate
            ? "flex w-full min-w-0"
            : "inline-flex shrink-0 align-middle",
          className,
        )}
        {...props}
      >
        {leftIcon && (
          <span
            aria-hidden="true"
            className="flex shrink-0 items-center justify-center [&_svg]:size-4"
          >
            {leftIcon}
          </span>
        )}
        <span
          className={cn(
            "leading-[1.5]",
            truncate ? "flex-1 truncate min-w-0" : "whitespace-nowrap",
          )}
        >
          {children}
        </span>
        {rightIcon && (
          <span
            aria-hidden="true"
            className="flex shrink-0 items-center justify-center [&_svg]:size-4"
          >
            {rightIcon}
          </span>
        )}
        {rightAction && (
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation()
              rightAction.onClick()
            }}
            aria-label={rightAction.ariaLabel}
            className="flex size-7 shrink-0 items-center justify-center rounded-full text-foreground outline-none ring-offset-background transition-colors hover:bg-border focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 [&_svg]:size-4"
          >
            {rightAction.icon}
          </button>
        )}
      </span>
    )
  },
)
JuloBadge.displayName = "JuloBadge"

export { JuloBadge }
export type { JuloBadgeProps, JuloBadgeRightAction }
